// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonRoles = {
  admin: "管理员",
  question_editor: "题库编辑",
  exam_manager: "考试管理员",
  reviewer: "阅卷员",
  proctor: "监考员",
  candidate: "考生",
  platform_user: "平台用户",
} as const;
